// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CiscoIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#02C8FF"
      d="M2 14.57a.83.83 0 0 0 1.66 0v-1.85a.83.83 0 0 0-1.66 0zM6.59 14.57a.83.83 0 0 0 1.66 0v-4.13a.83.83 0 0 0-1.66 0zM11.16 16.23a.83.83 0 0 0 1.65 0V7.3a.83.83 0 0 0-1.65 0zM15.76 14.57a.83.83 0 0 0 1.66 0v-4.13a.83.83 0 0 0-1.66 0zM20.34 14.57a.83.83 0 0 0 1.66 0v-1.85a.83.83 0 0 0-1.66 0z"
    />
  </svg>,
  "Cisco",
);
export default CiscoIcon;
